const INVALID_REDIRECT = 'Received an invalid redirect URL from the server.';

/**
 * The Stripe-hosted URL to redirect to (Checkout or Customer Portal), or a thrown `Error` when the hub's `url`
 * isn't one. Guards against a malformed or compromised response turning into an open-redirect, phishing or
 * `javascript:` URL: only `https:` on `stripe.com` or a subdomain of it is accepted.
 */
export function toStripeRedirectUrl(url: string): string {
  let parsed: URL;
  try {
    parsed = new URL(url);
  } catch {
    throw new Error(INVALID_REDIRECT);
  }
  const isStripeHost = parsed.hostname === 'stripe.com' || parsed.hostname.endsWith('.stripe.com');
  if (parsed.protocol !== 'https:' || !isStripeHost) {
    throw new Error(INVALID_REDIRECT);
  }
  return parsed.href;
}
